import { API, Logger } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import Auth from "@/services/Auth.js"
import axios from "axios";
const logger = new Logger('API')

const API_NAME = 'PVAPI'
const API_PERMISSIONS = 'PERMISSIONS'

const firmwareURL = orgId => `/org/${orgId}/firmware`
const firmwareIdURL = (orgId, firmwareId) => `/org/${orgId}/firmware/${firmwareId}`

export const getToken = async () => {
    const token = await Auth.currentSession()
    return token.accessToken
}

export const getOptions = async params => {
    logger.info('PARAMS', params)
    return {
        body: params || null,
        headers: {
            Authorization: await getToken()
        }
    }
}

// adds a hide message option
export const handleError = async (err, hideMessage = false) => {
    // if we don't want to show the message, just return the error
    if(hideMessage) {
        return err
    }

    if (err.response) {
        logger.error(err.response)
        AmplifyEventBus.$emit('snackEvent', {
            color: 'error',
            text: err.response.data.message
        })

        return err
    } else {
        AmplifyEventBus.$emit('snackEvent', {
            color: 'error',
            text: err.message
        })

        return err
    }
}

export async function ListOrgs(page = 0, previousRes = []) {
    try {
        const options = await getOptions()
        let res = await API.get(API_NAME, `/org?page_num=${page}`, options)
        let latestResults = res.Orgs

        if(latestResults.length == 50) {
            page ++
            logger.info('compare : ', previousRes, latestResults)
            

            
            let nextPage = await ListOrgs(page, latestResults)
            let combineRes = [...nextPage, ...latestResults]
            
            logger.info('test : ', combineRes)
            return combineRes
        }
        

        return latestResults
    } catch (err) {
        return handleError(err)
    }
}

export async function ListAccessibleOrgs(page = 0, previousRes = []) {
    try {
        const options = await getOptions()
        let res = await API.get(API_NAME, `/org/orgaccess?page_num=${page}`, options)
        let latestResults = res.Orgs

        if(latestResults.length == 50) {
            page ++
            logger.info('compare : ', previousRes, latestResults)
            

            
            let nextPage = await ListAccessibleOrgs(page, latestResults)
            let combineRes = [...nextPage, ...latestResults]
            
            logger.info('test : ', combineRes)
            return combineRes
        }
        

        return latestResults
    } catch (err) {
        return handleError(err)
    }
}


/**
 * @param {String} name
 * @param {String} primaryPhone
 * @param {String} primaryEmail
 * @param {String} secondaryPhone
 * @param {String} secondaryEmail
 */
export async function CreateOrg(params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, '/org', options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 */
export async function GetOrg(id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} primaryPhone
 * @param {String} primaryEmail
 * @param {String} secondaryPhone
 * @param {String} secondaryEmail
 */
export async function UpdateOrg(name, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} address_l1 - required
 * @param {String} address_l2
 * @param {String} address_l3
 * @param {String} address_l4
 * @param {String} subregion - required
 * @param {String} region
 * @param {String} code - required
 * @param {String} country - required
 */
export async function CreateOrgAddress(name, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/addresses`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} id
 * @param {String} address_l1
 * @param {String} address_l2
 * @param {String} address_l3
 * @param {String} address_l4
 * @param {String} subregion
 * @param {String} region
 * @param {String} code
 * @param {String} country
 */
export async function UpdateOrgAddress(name, id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}/addresses/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} id
 */
export async function DeleteOrgAddress(name, id) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${name}/addresses/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 */
export async function ListOrgInvites(name) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/invites`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} id
 */
export async function GetOrgInvite(name, id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/invites/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} enabled
 */
export async function UpdateOrgStatus(name, enabled) {
    try {
        const options = await getOptions({ enabled })
        const res = await API.put(API_NAME, `/org/${name}/status`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 */
export async function GetOrgTree(name) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/tree`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} parentId - required
 * @param {String} leftId - required
 * @param {String} rightId - required
 * @param {String} targetId - required
 */
export async function MoveOrgNode(name, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}/tree`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 * AssignUserToNode
 *
 * @export
 * @param {*} name
 * @param {*} id
 * @param {*} params
 * @returns
 */
export async function AssignUserToNode(name, id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/tree/nodes/${id}/users`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 * AssignVehicleToNode
 *
 * @export
 * @param {*} name
 * @param {*} id
 * @param {*} params
 * @returns
 */
export async function AssignVehicleToNode(name, id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/tree/nodes/${id}/vehicles`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} parentId - required
 * @param {String} label - required
 */
export async function CreateOrgNode(name, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/tree/nodes`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} id - required
 */
export async function DeleteOrgNode(name, id) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${name}/tree/nodes/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} connectionId - required
 */
export async function SubscribeToOrgTreeUpdates(name, connectionId) {
    try {
        const options = await getOptions({ connectionId })
        const res = await API.post(API_NAME, `/org/${name}/tree/nodes/subscriptions`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetUnassignedDevicePresence() {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/unassigned/presence`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    } 
}

/**
 *
 * @param {String} name - required
 */
export async function ListOrgUsers(name, verbose = false) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/users${verbose ? '/verbose/?include_hidden=true' : ''}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} email - required
 */
export async function GetUserByEmail(email) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/user/${email}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} email - required
 */
export async function GetUserInOrgByEmail(name, email) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/users/${email}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name - required
 * @param {String} role - required
 */
export async function GetUsersInOrgByRole(name, role) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/users?role="${role}"`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} org name - required
 * @param {String} email - required
 * @param {String} firstname
 * @param {String} lastname
 * @param {String} photo
 * @param {String} telephone
 * @param {String} mobile
 */
export async function UpdateUserInOrg(name, email, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}/users/${email}`, options)
        logger.info(res)
        return res
    } catch (err) {
        throw new Error(handleError(err))
    }
}

/**
 *
 * @param {String} name
 * @param {String} email
 * @param {String} address_l1
 * @param {String} address_l2
 * @param {String} address_l3
 * @param {String} address_l4
 * @param {String} subregion
 * @param {String} region
 * @param {String} code
 * @param {String} country
 */
export async function CreateUserAddressInOrg(name, email, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/users/${email}/addresses`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} email
 * @param {String} id
 * @param {String} address_l1
 * @param {String} address_l2
 * @param {String} address_l3
 * @param {String} address_l4
 * @param {String} subregion
 * @param {String} region
 * @param {String} code
 * @param {String} country
 */
export async function UpdateUserAddressInOrg(name, email, id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}/users/${email}/addresses/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} email
 * @param {String} enabled - 'ture'/'false'
 */
export async function UpdateUserStatusInOrg(name, email, enabled) {
    try {
        const options = await getOptions({ email, enabled })
        const res = await API.put(API_NAME, `/org/${name}/users/${email}/status`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} email
 */
export async function GetInvitesCreatedByUser(name, email) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/user/${email}/invites`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} org
 * @param {String} nodeId
 * @param {String} vehicleName
 * @param {String} vehicleType
 */
export async function CreateOrgVehicle(name, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${name}/vehicles`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} vehicleName
 */
export async function GetOrgVehicleByName(name, vehicleName, isVerbose = false) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/vehicles/${vehicleName}${isVerbose ? '/verbose' : ''}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetActivityReport(orgID, userEmail, [start, end]) {
    try {
        const options = await getOptions({
            action: "get",
            "report_filters": {
                "entity_id": [userEmail],
                "start_time": start,
                "end_time": end,
                "activity_type":["login"]
            }
        })

        const res = await API.post(API_NAME, `/org/${orgID}/reports/user_activity`, options)
        
        logger.info(res)
        return res
    }   
    catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 */
 export async function GetOrgVehicles(name, isVerbose = false, page = 0, previousRes = []) {
    try {
        const options = await getOptions()
        let res = await API.get(API_NAME, `/org/${name}/vehicles${isVerbose ? '/verbose' : ''}?page_num=${page}`, options)
        let latestResults = res.Vehicles
        let totalPages = Math.min(res.total_pages, 30)

        // hate having an indefinete while loop, so we limit this to 20 pages or 10000 vehicles
        while (totalPages > page + 1) {
            page++
            logger.info('compare : ', previousRes, latestResults)
            
            let nextPage = await GetOrgVehicles(name, isVerbose, page, latestResults)
            let combineRes = [...nextPage, ...latestResults]
            
            return combineRes
        }
  
        return latestResults
    } catch (err) {
        return handleError(err)
    }
}

/**
 * returns presence for an org
 * @param {String} name
 * @param {String} vehicleId
 */
 export async function GetOrgVehiclePresence(orgID, hideError = false) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${orgID}/vehicles/presence`, options)
        logger.info(res)
        return res.Presences
    } catch (err) {
        return handleError(err, hideError)
    }
}

export async function SubscribeVehicleUpdates(org, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${org}/vehicles/subscriptions`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} id
 */
export async function GetOrgVehiclesByNode(name, id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/tree/nodes/${id}/vehicles`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} vehicleName
 */
export async function UpdateOrgVehicle(name, vehicleName, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/org/${name}/vehicles/${vehicleName}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return false
    }
}

/**
 *
 * @param {String} name
 * @param {String} vehicleName
 */
export async function DeleteOrgVehicle(name, vehicleName) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${name}/vehicles/${vehicleName}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 */
 export async function GetOrgDevices(name, querystring = false) {
    try {
        const options = await getOptions()
        const url = querystring 
            ? `/org/${name}/devices/?${querystring}`
            : `/org/${name}/devices`
        const res = await API.get(API_NAME, url, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} type
 */
export async function GetOrgDevicesByDeviceType(name, type) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/devices?type=${type}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} id
 */
export async function GetOrgDevicesByDeviceID(name, id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/devices/id/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} uuid
 */
export async function GetOrgDevicesByUUID(name, uuid) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/devices/uuid/${uuid}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} name
 * @param {String} vehicleName
 */
export async function GetOrgDevicesByVehicle(name, vehicleName) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${name}/vehicles/${vehicleName}/devices`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *  @return {Promise}
 */
export async function ListVehicleTypes() {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/vehicleType`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *  @return {Promise}
 */
export async function ListDeviceTypes() {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/deviceType`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} deviceType
 */
export async function CreateDevice(deviceType) {
    try {
        const options = await getOptions({ deviceType })
        const res = await API.post(API_NAME, `/device`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *  @return {Promise}
 */
export async function GetUnassignedDevices(page = 0) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/unassigned?page_num=${page}&rows_per_page=1000&order_by=id`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *  @return {Promise}
 */
export async function ListAllRoles() {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/role/`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} email
 * @param {String} role
 * @param {String} org
 */
export async function CreatePendingInvite(params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/invites/`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} id
 */
export async function DeletePendingInviteByID(id) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/invites/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/*     "due_on": string,
    "name": string,
    "description": string,
    "assigned_to": string,
    "tasks": [
        {
            "name": string,
            "description": string,
            "assigned_to": string,
            "performed_by": string,
            "task_type": string,
            "num_devices": string,
            "due_on": string,
            "extra_install_instructions": string
        }
    ] */

export async function CreateJob(org, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${org}/job`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function NewJob(params) {
    try {
        const options = await getOptions(params);
        const res = await API.post(API_NAME, `/job`, options);
        logger.info(res);

        return res;
    }
    catch (err) {
        return false;
    }
}

export async function UpdateJob(id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/job/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function DeleteJob(id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.del(API_NAME, `/job/${id}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return false
    }
}

export async function GetJob(page, params) {
    try {
        const options = await getOptions(params)
        logger.info('options ', options)
        const res = await API.post(API_NAME, `/job/elastic?page_num=${page}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetJobArchived(params) {
    try {
        const options = await getOptions(params)
        logger.info('options ', options)
        const res = await API.post(API_NAME, `/job/elastic`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetJobPaginated(params, previousRes = []) {
    try {
        const options = await   (params)
        const res = await API.get(API_NAME, `/job`, options)
        logger.info('GetJobPaginated ', res)

        let latestResults = res.Jobs
        logger.info('pagination length : ', latestResults.length)
        if(latestResults.length == 100) {
            logger.info('compare : ', previousRes, latestResults)
            
            params.page_num ++;
            
            let nextPage = await GetJobPaginated(params, latestResults)
            let combineRes = [...nextPage, ...latestResults]
            
            return combineRes
        }
        

        return latestResults
    } catch (err) {
        return handleError(err)
    }
}

export async function GetJobById(params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/job/elastic/`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function AssignDeviceToVehicle(org, vehicle_id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `/org/${org}/vehicles/${vehicle_id}/devices`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function CreateFirmwarePackage(params) {
    try {
        const options = await getOptions(params)
        const res = await API.put(API_NAME, `/device/firmware/builds`, options)
        logger.info(res)
        return res
    } catch (err) {
        return err.response.data
    }
}

export async function uploadFirmwarePackage(file, config) {
    try {
        const form = new FormData();
        for (let [key, value] of Object.entries(config.fields)) {
            form.append(key, value);
        }
        form.append('file', file);
        const res = await axios.post(config.url, form, {})
        logger.info(res)
        return res
    } catch (err) {
        return false
    }

}
 
export async function GetFirmwarePackage(id, params) {
    try {
        const options = await getOptions(params)
        const res = await API.get(API_NAME, firmwareURL(id), options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetFirmwarePackageById(id, firmwareId, params) {
    try {
        const options = await getOptions(params)
        const res = await API.get(API_NAME, firmwareIdURL(id, firmwareId), options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function DeleteFirmwarePackage(firmwareId) {
    try {
        const options = await getOptions({
            fw_build_id: firmwareId
        })
        const res = await API.del(API_NAME, `/device/firmware/builds`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function CreateFirmwareUpdateJob(id, firmwareId, params) {
    try {
        const options = await getOptions(params)
        const res = await API.post(API_NAME, `${firmwareIdURL(id, firmwareId)}/job`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetContacts(orgID) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${orgID}/users/contacts`, options)
        
        logger.info(res)
        return res
    }   
    catch (err) {
        return handleError(err)
    }
}

export async function GetDeviceConfig(id, format) {
    try {
        const options = await getOptions();

        const res = await API.get(API_NAME, `/device/${id}/config/format/${format}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return false
    }
}

export async function UpdateDeviceConfigOTA(orgID, id, format, params) {
    try {
        const options = await getOptions(params);
        const res = await API.put(API_NAME, `/org/${orgID}/devices/id/${id}/config/format/${format}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

/**
 *
 * @param {String} id
 * @param {String} id
 */
export async function GetOrgDeviceInfo(orgID, deviceID) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${orgID}/devices/id/${deviceID}/info`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function GetDeviceInfo(id) {
    try {
        const options = await getOptions();
        const res = await API.get(API_NAME, `/device/${id}/info`, options);

        return res;
    } catch (err) {
        return handleError('GetDeviceInfo', err);
    }
}

export async function GetOrgAlertsConfig(orgID) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${orgID}/vehicles/config/alerts`, options)
        
        logger.info(res);
        return res;
    }   
    catch (err) {
        return handleError(err);
    }
}

export async function GetVehicleAlertsConfig(orgID, vehicleId) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${orgID}/vehicles/${vehicleId}/config/alerts`, options)
        
        logger.info(res);
        return res;
    }   
    catch (err) {
        return handleError(err);
    }
}

export async function GetAutoUploadSetting(orgID, devices) {
    try {
        const options = await getOptions({
            "devices": devices
        });
        const res = await API.post(API_NAME, `/org/${orgID}/au/settings`, options);

        return res;
    }
    catch (err) {
        return handleError('GetAutoUploadSetting', err);
    }
}

export async function UpdateVehicleAlertsConfig(orgID, name, payload) {
    try {
        const options = await getOptions(payload)
        logger.info('UpdateVehicleAlertsConfig', options);
        const res = await API.put(API_NAME, `/org/${orgID}/vehicles/${name}/config/alerts`, options)
        
        logger.info(res);
        return res;
    }   
    catch (err) {
        return handleError(err);
    }
}

export async function CreateAlertNotification(orgID, payload) {
    try {
        const options  =  await  getOptions({
            "notification": payload
        });
        const res = await API.post(API_NAME, `/org/${orgID}/alerts/notifications/configs`,options);

        return res;
    } 
    catch (err) {
        return handleError('CreateAlertNotification', err);
    }
}

export async function UpdateAutoUploadSettings(orgID, devices, payload) {
    try {
        const options = await getOptions({
            "devices": devices,
            "configs": payload
        });
        const res = await API.put(API_NAME, `/org/${orgID}/au/settings`, options);

        return res;
    }
    catch (err) {
        return handleError('UpdateAutoUploadSettings', err);
    }
}

export async function UnassignDeviceFromVehicle(orgID, vehicleId, deviceId) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${orgID}/vehicles/${vehicleId}/devices/${deviceId}`, options)
        logger.info(res)
        return res
    } catch (err) {
        return handleError(err)
    }
}

export async function RegenerateOTC(deviceId) {
    try {
        const options = await getOptions();
        const res = await API.post(API_NAME, `/pendingdevice/id/${deviceId}/otc`, options)

        return res;
    } catch (err) {
        return handleError(err);
    }
}

export async function DeletePendingDevice(deviceId) {
    try {
        const options = await getOptions();
        const res = await API.del(API_NAME, `/pendingdevice/id/${deviceId}`, options)

        return res;
    } catch (err) {
        return handleError(err);
    }
}

export async function DeleteUnassignedDevice(deviceId) {
    try {
        const options  =  await  getOptions({
            "attribute":"id",
            "value": deviceId
        });
        const res = await API.del(API_NAME, `/device/unassigned`, options)
        logger.info('DeleteUnassignedDevice ', res)
        if(res.deleted_devices && res.deleted_devices.length > 0) {
            return true
        } else {
            return false
        }
    } catch (err) {
        return handleError(err);
    }
}

export async function GetPendingDevicesByOrg(org) {
    try {
        const options = await getOptions();
        const res = await API.get(API_NAME, `/pendingdevice?org=${org}`, options)

        return res;
    } catch (err) {
        return handleError(err);
    }
}

export async function CreateEmailAlert(orgID, payload) {
    try {
        const options  =  await  getOptions(payload);
        const res = await API.put(API_NAME, `/org/${orgID}/vehicles/email_list/alerts `,options);

        return res;
    } 
    catch (err) {
        return handleError('CreateAlertNotification', err);
    }
}

export async function FormatDisk(deviceID, payload) {
    try {
        const options = await getOptions(payload);
        const res = await API.post(API_NAME, `/device/${deviceID}/formatDisk`, options);
        
        return res;
    }
    catch (err) {
        return handleError(err);
    }
}

export async function RebootDevice(orgID, deviceID) {
    try {
        const options = await getOptions();
        const res = await API.post(API_NAME, `/org/${orgID}/devices/id/${deviceID}/reboot`, options);

        return res;
    }
    catch (err) {
        return handleError('RebootDevice', err);
    }
}

export async function GetOrgFaults(org) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${org}/vehicles/faults`, options)
        
        return res
    } catch (err) {
        return handleError('GetOrgFaults', err);
    }
}

export async function GetFaultReport(type, dates) {
    try {
        const range = {
            start_date: dates[0],
            end_date: dates[1]
        }
        const searchParams = new URLSearchParams(range);
        const options = await getOptions()
        const res = await API.get(API_NAME, `/report/${type}?${searchParams}`, options)
        
        return res.Reports
    } catch (err) {
        return false;
    }
}

export async function getOrgDeviceInformation(org, devices) {
    try {
        const payload = {
            "deviceIds": devices
        }
        const options = await getOptions(payload)
        const res = await API.post(API_NAME, `/org/${org}/devices/info`, options)
        
        return res
    } catch (err) {
        return false;
    }
}

export async function deleteOrgUser(org, user) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${org}/ousers/${user}/delete`, options)

        return res
    } catch (err) {
       return false
    }
}

export async function getOrgAPIKey(org) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/org/${org}/apikey`, options)

        return res
    } catch (err) {
        return false
    }
}

export async function disableOrgAPIKey(org) {
    try {
        const options = await getOptions()
        const res = await API.del(API_NAME, `/org/${org}/apikey`, options)

        return res
    } catch (err) {
        return false
    }
}

export async function enableAPIKey(org, user) {
    try {
        const options = await getOptions({})
        const res = await API.put(API_NAME, `/org/${org}/ousers/${user}/apikey`, options)

        return res
    } catch (err) {
        return false
    }
}

export async function updateUserRole(org, email, role) {
    try {
        const payload = {
            role: role
        }
        const options = await getOptions(payload)
        const res = await API.put(API_NAME, `/org/${org}/ousers/${email}/role`, options)
        return res
    } catch (err) {
        return err.response.data.message
    }
}

export async function quickSearch(params) {
    try {
        const options = await getOptions(params)
        const res = API.post(API_NAME, '/search', options)

        return res
    } catch(error) {
        return error.response.data.message
    }
}

export async function UserActivityReport(orgID, dates, users) {
    try {
        const options = await getOptions({
            action: "get", 
            "report_filters": { 
                "entity_id": users,
                "start_time": dates[0],
                "end_time": dates[1],
                "activity_type":["login"]
            }
        });

        const res = await API.post(API_NAME, `/org/${orgID}/reports/user_activity`, options);

        logger.info(res);
        return res;
    } catch (err) {
        return handleError(err);
    }
}

export async function listOrgAccessForUsers(users) {
    try {
        const options =  await getOptions({
            users: users
        });

        const res = await API.post(API_NAME, `/user/org_access`, options);

        return res;
    }
    catch (err) {
        return handleError(err)
    }
}

export async function addOrgAccessForUsers(users, accessAll) {
    try {
        const options =  await getOptions({
            access_all: accessAll,
            users: users
        });

        const res = await API.put(API_NAME, `/user/org_access`, options);

        return res;
    }
    catch (err) {
        return handleError(err)
    }
}
export async function GetPermissions() {
    try {
        const options = await getOptions({})
        const res = await API.post(API_PERMISSIONS, `/permissions/actions`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function UpdatePermissions(permissions) {
    try {
        const options = await getOptions(permissions)
        const res = await API.put(API_PERMISSIONS, `/permissions/user`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function UserPermissions(permissions) {
    try {
        const options = await getOptions(permissions)
        const res = await API.post(API_PERMISSIONS, `/permissions/user`, options)
        return res
    } catch(err) {
        return false
    }
}

/**
 *
 * @param {String} orgId
 * @param {String} vehicleId
 */
export async function GetOrgVehicleById(orgId, vehicleId, verbose = false) {
    try {
        const options = await getOptions()
        const url = verbose
            ? `/org/${orgId}/vehicles/${vehicleId}/verbose`
            : `/org/${orgId}/vehicles/${vehicleId}`

        const res = await API.get(API_NAME, url, options)
        logger.info(res)
        return res
    } catch (err) {
        return false
    }
}

export async function moveVehiclesBetweenOrgs(orgId, payload) {
    try {
        const options = await getOptions(payload)
        const res = await API.post(API_NAME, `/org/${orgId}/vehicles/move`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareBuilds(page) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/builds?page_num=${page}`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRollouts(page) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts?page_num=${page}`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRolloutDetails(id, page) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts/details?fw_rollout_id=${id}&action=get_page&page_num=${page}`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRolloutDetailsSearch(id, page, searchParams) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts/details?fw_rollout_id=${id}&action=get_page&page_num=${page}&${searchParams}`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRolloutDetailsFull(id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts/details?fw_rollout_id=${id}&action=get_full`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRolloutDetailsAgg(id) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts/details?fw_rollout_id=${id}&action=get_agg`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getFirmwareRolloutStats(model) {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/rollouts/stats?device_model=${model}`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function updateFirmwareRollout(id) {
    try {
        const options = await getOptions({
            fw_rollout_id: id,
            action: "withdraw"
        })
        const res = await API.post(API_NAME, `/device/firmware/rollouts`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function createFirmwareRollout(payload) {
    try {
        const options = await getOptions(payload)
        const res = await API.put(API_NAME, `/device/firmware/rollouts`, options)
        return res
    } catch(err) {
        return false
    }
}

export async function getDeviceModels() {
    try {
        const options = await getOptions()
        const res = await API.get(API_NAME, `/device/firmware/models`, options)
        return res
    } catch(err) {
        return false
    }
}